import { Page } from '@/components';
import SupplyWalletsTable from './SupplyWalletsTable';
import { Flex, TextSearchFilter, useTableProps } from '@blockanalitica/ui';
import HistoricGraphs from './HistoricGraphs';

export default function SuppliersWalletsPage() {
  const { filters } = useTableProps({
    filtersDebounceTime: 500,
    initialFilters: {
      textSearch: ''
    }
  });

  return (
    <Page title="Supplier Wallets">
      <HistoricGraphs />
      <Flex flexDirection="row" alignItems="center" justifyContent="flex-end">
        <TextSearchFilter placeholder="Search by address" {...filters} />
      </Flex>
      <SupplyWalletsTable search={filters.filtersApplied['textSearch']} />
    </Page>
  );
}
